import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PromoTypeEnum } from 'app/models';
import { PartnerFinanceTransactionsComponent } from 'app/partner';
import * as moment from 'moment';
import { PromoStatus } from 'app/models/enums/promo-status.enum';

@Component({
    selector: 'partner-finance-transaction-filter',
    templateUrl: './partner-finance-transaction-filter.component.html',
    styleUrls: ['./partner-finance-transaction-filter.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ]
})
export class PartnerFinanceTransactionFilterComponent implements OnInit {

    @Input()
    public visiblePartnerFinanceTransactionFilter: boolean = false;

    @Input() partnerFinanceTransactionsComponent!: PartnerFinanceTransactionsComponent;

    public filterObj: any = {};
    @Input()
    set _filterObj(obj: any) {
        this.filterObj = obj;
        if (this.filterObj.StartedAt) {
            this.filterObj.StartedAt = new Date(this.filterObj.StartedAt);
        }
        if (this.filterObj.ValidUntil) {
            this.filterObj.ValidUntil = new Date(this.filterObj.ValidUntil);
        }
    }

    @Output() changedShowPartnerFinanceTransactionFilterSideBarEmit = new EventEmitter<boolean>();
    changedShowPartnerFinanceTransactionFilterSideBar(increased: boolean) {
        this.changedShowPartnerFinanceTransactionFilterSideBarEmit.emit(increased);
    }

    constructor() { }

    ngOnInit(): void { }

    public clickStatus(status: PromoStatus) {
        this.filterObj.Status = status;
    }

    public uncheckFilter() {
        this.filterObj = {};
    }

    public clickFilter() {
        if (this.filterObj.StartedAt) {
            this.filterObj.StartedAt = moment(this.filterObj.StartedAt).format('YYYY-MM-DD');
        }
        if (this.filterObj.ValidUntil) {
            this.filterObj.ValidUntil = moment(this.filterObj.ValidUntil).format('YYYY-MM-DD');
        }
        this.partnerFinanceTransactionsComponent.getMerchantTransactions(0, this.filterObj);
        this.cancel();
    }

    public cancel() {
        this.changedShowPartnerFinanceTransactionFilterSideBar(false);
    }

    protected readonly PromoStatus = PromoStatus;
}
